(function() {
  'use strict';
  function CredentialList (container) {
    this.form = container.querySelector("[data-type='lns-credentials-filter-form']");
    this.list = container.querySelector("[data-type='lns-credentials-filter-list']");
    this.items = this.list.querySelectorAll('[data-type="filter-item"]');
    this.items = Array.prototype.slice.call(this.items, 0);
    this.formBubbles = container.querySelector("[data-type='lns-credentials-filter-bubbles']");
    // try to find a unique storage identifier
    this.store = null;
    let params = new URLSearchParams(window.location.search);
    function findClosest(el, s) {
      let dest = null;
      do {
        dest = el.querySelector(s);
        if (dest) return dest;
        el = el.parentElement || el.parentNode;
      } while (el !== null && el.nodeType === 1);
      return null;
    }
    // generate store name
    this.store = window.location.pathname;
    let id = this.list.id;
    if (id) {
      this.store = this.store + '/' + id;
    }
    let t, tab = findClosest(this.list, 'ul.tabsheets > li.tabsheet-item > .sheet-header');
    if (tab) {
      t = tab.innerHTML;
      this.store = this.store + '/#' + t;
    }
    let q = params.get("tx_solr[q]");
    if (q) {
      this.store = this.store + '/' + q;
    }
    this.step = 0;
    this.count = 0;
    this.industry = 'all';
    this.technology = 'all';
    this.query = '';
    this.filterIndustry = this.form.querySelector('[data-type="lns-credentials-filter-industry"]');
    this.filterTechnology = this.form.querySelector('[data-type="lns-credentials-filter-technology"]');
    this.filterQuery = this.form.querySelector('[data-type="lns-credentials-filter-query"]');
    this.filterReset = this.form.querySelector('[data-type="lns-credentials-filter-reset"]');
    this.init();
  }
  CredentialList.prototype = {
    getSessionStorageValues: function () {
      let configJSON = sessionStorage.getItem('credentialfilter-' + this.store);
      let config = JSON.parse(configJSON);
      if (config) {
        if (this.filterIndustry) {
          this.industry = config.industry;
          this.filterIndustry.value = config.industry;
        }
        if (this.filterTechnology) {
          this.technology = config.technology;
          this.filterTechnology.value = config.technology;
        }
        if (this.filterQuery) {
          this.query = config.query;
          this.filterQuery.value = config.query;
        }
      }
    },
    setSessionStorageValues: function () {
      let config = {
        'industry': this.industry,
        'technology': this.technology,
        'query': this.query
      };
      let configJSON = JSON.stringify(config);
      sessionStorage.setItem('credentialfilter-' + this.store, configJSON);
    },
    sortItems: function () {
      let direction = 'asc';
      var sortByInt = function(el1, el2) {
        let value1 = parseInt(el1.getAttribute('data-filter-sort'), 10);
        let value2 = parseInt(el2.querySelector('data-filter-sort'), 10);
        let res = value1 - value2;
        return (direction === 'asc' ? res : res * -1);
      };
      this.items.sort(sortByInt);
      for (let i = 0; i < this.items.length; i++) {
        this.list.appendChild(this.items[i]);
      }
    },
    moveHidden: function () {
      for (let i = this.items.length-1; i >= 0; i--) {
        if (this.items[i].style.display == 'none') {
          this.items[i].parentNode.appendChild(this.items[i]);
        }
      }
    },
    reset: function (el) {
      if (el) {
        switch (el.id) {
          case 'industry':
            this.industry = 'all';
            break;
          case 'technology':
            this.technology = 'all';
            break;
        }
      } else {
        this.industry = 'all';
        this.technology = 'all';
        this.query = '';
      }
      this.setSessionStorageValues();
      this.getSessionStorageValues();
      this.filter();
    },
    setIndustry: function (value) {
      this.industry = value;
      this.filter();
      this.setSessionStorageValues();
    },
    setTechnology: function (value) {
      this.technology = value;
      this.filter();
      this.setSessionStorageValues();
    },
    setQuery: function (value) {
      this.query = value;
      this.filter();
      this.setSessionStorageValues();
    },
    matchIndustry: function (item) {
      if (!this.filterIndustry || (this.industry === 'all')) {
        return true;
      }
      if (item.getAttribute('data-filter-industry')) {
        let industry = item.getAttribute('data-filter-industry');
        return (this.industry === industry);
      }
      return false;
    },
    matchTechnology: function (item) {
      if (!this.filterTechnology || (this.technology === 'all')) {
        return true;
      }
      if (item.getAttribute('data-filter-technology')) {
        let technology = item.getAttribute('data-filter-technology');
        return (technology === this.technology);
      }
      return false;
    },
    matchQuery: function (item) {
      if (!this.filterQuery || (this.query === '')) {
        return true;
      }
      let txt = item.innerText;
      return (txt.toLowerCase().indexOf(this.query.toLowerCase()) !== -1);
    },
    filter: function () {
      this.removeFormBubbles();
      this.sortItems();
      let count = 0;
      for (let i = 0; i < this.items.length; i++) {
        if (this.matchIndustry(this.items[i]) &&
          this.matchTechnology(this.items[i]) &&
          this.matchQuery(this.items[i])) {
          this.items[i].style.display = '';
          count++;
        } else {
          this.items[i].style.display = 'none';
        }
      }
      this.moveHidden();
      this.updateFormBubbles();
    },
    getBubbleLabel: function (element, value) {
      const elementId = element.id;
      const elementLabel = this.form.querySelector('label[for="' + elementId + '"]');
      if (null === elementLabel) {
        return null;
      }
      let bubbleLabel = elementLabel.textContent.trim() + '';
      return bubbleLabel + ': ' + value;
    },
    isSelectField: function (element) {
      return 'select-one' === element.type
    },
    isCheckbox: function (element) {
      return 'radio' === element.type
        || 'checkbox' === element.type;
    },
    isActiveCheckbox: function (element) {
      return true === element.checked;
    },
    createBubbleElement: function (label) {
      const bubbleElement = document.createElement('div');
      const bubbleLabelNode = document.createTextNode(label);
      bubbleElement.setAttribute('type', 'button');
      bubbleElement.setAttribute('tabindex', '0');
      bubbleElement.classList.add('lns-filter-bubble');
      bubbleElement.appendChild(bubbleLabelNode);
      const bubbleClose = document.createElement('div');
      bubbleClose.classList.add('lns-filter-bubble-close');
      bubbleElement.appendChild(bubbleClose);
      return bubbleElement;
    },
    addBubble: function (element, value) {
      const bubbleLabel = this.getBubbleLabel(element, value);
      if (null === bubbleLabel) {
        return;
      }
      const bubble = this.createBubbleElement(bubbleLabel);
      this.formBubbles.appendChild(bubble);
      bubble.addEventListener(
        'click',
        () => this.reset(element),
        false
      );
      bubble.addEventListener(
        'keydown',
        (event) => {
          if (event.keyCode === 32) {
            event.preventDefault();
            event.target.click();
          }
        },
        false
      );
    },
    removeFormBubbles: function () {
      while (this.formBubbles.firstChild) {
        this.formBubbles.removeChild(this.formBubbles.firstChild);
      }
    },
    addFormBubble: function (element) {
      const elementValue = element.value;
      if (true === this.isCheckbox(element)) {
        if (true === this.isActiveCheckbox(element)) {
          this.addBubble(element, '')
        }
        return;
      }
      if (true === this.isSelectField(element)) {
        if (('' !== elementValue) && ('0' !== elementValue) && ('all' !== elementValue)) {
          const selectedLabel = element.options[element.selectedIndex].text;
          this.addBubble(element, selectedLabel);
        }
        return;
      }
      if ('' !== elementValue) {
        this.addBubble(element, ' ' + elementValue);
      }
    },
    updateFormBubbles: function () {
      const formElements = this.form.querySelectorAll('input, select');
      formElements.forEach(element => {
        this.addFormBubble(element)
      });
    },
    init: function() {
      const self = this;
      if (this.filterReset) {
        this.filterReset.addEventListener('click', function() {
          self.reset();
        });
      }
      this.updateFormBubbles();
      if (this.filterIndustry) {
        this.filterIndustry.addEventListener('change', function () {
          self.setIndustry(this.options[this.selectedIndex].value);
        });
      }
      if (this.filterTechnology) {
        this.filterTechnology.addEventListener('change', function () {
          self.setTechnology(this.options[this.selectedIndex].value);
        });
      }
      if (this.filterQuery) {
        let timeout;
        const searchWait = function (e) {
          clearTimeout(timeout);
          let search = e.target.value;
          timeout = setTimeout(function () {
            self.setQuery(search);
          }, 500);
        };
        this.filterQuery.addEventListener('keyup', searchWait);
        this.filterQuery.addEventListener('input', searchWait);
      }
      this.getSessionStorageValues();
      this.filter();
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    /** @type {NodeListOf<Element>} */
    let containers = document.querySelectorAll('[data-type="lns-credentials-filter-wrap"]');
    for (let i = 0; i < containers.length; i++) {
      new CredentialList(containers[i]);
    }
  })
})();
